var _path, _path2, _path3, _rect, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 85,
    viewBox: "0 0 80 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.5487 73.8231C50.3163 84.0895 34.5094 84.9278 24.243 75.6954L11.8478 64.5488C1.58131 55.3164 0.743021 39.5095 9.97538 29.2431L34.4954 1.97663C36.3418 -0.0766642 39.5032 -0.244325 41.5565 1.60214L68.823 26.1221C79.0894 35.3545 79.9277 51.1614 70.6954 61.4279L59.5487 73.8231Z",
    fill: "#E8F5EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1521 23.4677C45.0834 23.1531 48.1741 25.798 48.4962 31.8706L48.6934 35.5895C48.7109 35.919 48.5375 36.2114 48.2873 36.3899C43.2392 39.5608 36.79 39.9029 31.4348 37.2837C31.3629 37.2639 31.2886 37.197 31.2142 37.1302C31.0407 36.9741 30.9341 36.7437 30.9216 36.5084L30.7269 32.8366C30.5671 29.8238 31.1584 27.6209 32.5403 26.0842C33.989 24.4732 36.1393 23.6275 39.1521 23.4677Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0157 41.3065C33.6872 41.507 34.334 41.6851 35.0005 41.7914C35.5258 41.9051 36.0733 41.9941 36.6184 42.036C37.0471 42.1076 37.5923 42.1496 38.1597 42.1667C38.2315 42.1865 38.3975 42.2013 38.6552 42.164C39.5768 42.1859 40.7067 42.1261 41.8092 41.9968C41.881 42.0166 42.0668 41.9595 42.2997 41.8999C42.6515 41.8577 43.1891 41.7583 43.749 41.6342C44.1701 41.5647 44.7053 41.4183 45.2156 41.2496C45.8424 41.0511 46.4914 40.8279 47.0909 40.5601C47.7597 40.2649 48.3345 39.9749 48.9092 39.6847L49.8503 57.4317C49.9127 58.6086 49.4575 60.2614 48.8236 61.2155L44.9063 67.0173C44.0991 68.2638 42.8631 68.9903 41.5698 69.0825C40.4871 69.1399 39.4264 68.7241 38.5589 67.944C38.3607 67.7656 38.2095 67.5849 38.0335 67.3818L33.5245 62.0269C32.7932 61.1451 32.1658 59.5498 32.1033 58.3729L31.1621 40.6259C31.7643 40.8536 32.3665 41.0813 33.0157 41.3065Z",
    fill: "#292D32"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 20,
    width: 50,
    height: 50,
    rx: 25,
    fill: "#00861E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 43.3838L46.049 37.3347C46.4953 36.8884 47.219 36.8884 47.6653 37.3347C48.1116 37.781 48.1116 38.5047 47.6653 38.951L41.6162 45L47.6653 51.049C48.1116 51.4953 48.1116 52.219 47.6653 52.6653C47.219 53.1116 46.4953 53.1116 46.049 52.6653L40 46.6162L33.951 52.6653C33.5047 53.1116 32.781 53.1116 32.3347 52.6653C31.8884 52.219 31.8884 51.4953 32.3347 51.049L38.3838 45L32.3347 38.951C31.8884 38.5047 31.8884 37.781 32.3347 37.3347C32.781 36.8884 33.5047 36.8884 33.951 37.3347L40 43.3838Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageClose);
export default __webpack_public_path__ + "static/media/message-close.a229152208b547f65d1e3844b0e8276b.svg";
export { ForwardRef as ReactComponent };